module.exports = __webpack_public_path__ + "media/images/countrysquared/de-bc585eed46c04b18af2ed1a2cf9b512f.svg";